export default __webpack_public_path__ + "static/media/insulation_1.abf74810.JPG";